<template>
    <div class="availableRooms">
        <div class="row">
            <div class="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-12">
                <div class="text-center">
                    <strong>{{date | moment("dddd D. MMMM YYYY")}}</strong>
                </div>

                <br />

                <loader v-if="!hasLoaded"></loader>

                <table class="table" v-else>
                    <tbody>
                        <tr v-for="type in types" :key="type.id">
                            <td class="col-md-6">
                                {{type.title}}
                            </td>

                            <td class="col-md-6 text-right">
                                <template v-if="availableRooms[type.id] !== undefined">
                                    {{availableRooms[type.id]}} room(s)
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .availableRooms {
        overflow: hidden;

        .loader {
            padding: 0 0;
            margin-top: -60px;
        }
    }
</style>

<script>
    import Loader from '@/components/layout/Loader'

    const RoomService = require('@/services/rooms/RoomService')
    const ReservationService = require('@/services/reservations/ReservationService')

    export default {
        props: {
            date: Object,
            types: Array
        },

        data() {
            return {
                hasLoaded: false,
                availableRooms: {}
            }
        },

        watch: {
            date() {
                this.load()
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                this.availableRooms = {}

                this.types.forEach((type) => {
                    const options = {
                        filter_groups: [
                            {
                                filters: [
                                    {
                                        key: 'type',
                                        value: type.id,
                                        operator: 'eq'
                                    }
                                ]
                            }
                        ]
                    }

                    RoomService.findAll(options, (response) => {
                        const rooms = response.data
                        const total = rooms.total

                        ReservationService.findAll({
                            includes: ['room'],

                            filter_groups: [
                                {
                                    filters: [
                                        {
                                            key: 'room.type',
                                            value: type.id,
                                            operator: 'eq'
                                        },
                                        {
                                            key: 'belongsToDate',
                                            value: this.date.format('YYYY-MM-DD'),
                                            operator: 'eq'
                                        },
                                    ]
                                }
                            ]
                        }, (response) => {
                            const reservations = response.data

                            this.$set(this.availableRooms, type.id, rooms.total - reservations.total)
                        })
                    })
                })

                this.hasLoaded = true
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// AvailableRooms.vue?4aa3fcce